import { createApp, h } from 'vue'
import { createInertiaApp, Head, Link } from '@inertiajs/vue3'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { ZiggyVue } from 'ziggy-js'
import vueCountryRegionSelect from 'vue3-ts-country-region-select'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { faBell } from '@fortawesome/free-regular-svg-icons'
import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";

import "@/scss/app.scss";
import "@/css/app.css";
import "@/css/tailwind.css";


library.add(faAngleDown);
library.add(faBell);
library.add(faQuestionCircle);

createInertiaApp({
    //resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    title: title => `${title} | Vinyl Siding Institute`,
    resolve: (name) => resolvePageComponent(`../views/pages/${name}.vue`, import.meta.glob('../views/pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(vueCountryRegionSelect)
            .component('inertia-head', Head)
            .component('inertia-link', Link)
            .component('font-awesome-icon', FontAwesomeIcon)
            .mount(el)
    },
}).then().catch();
